import React from "react";
import { cn } from "@/lib/utils";

export function Logo({ className, color }: { className?: string, color?: string }) {
  return (
    <div 
      className={cn("inline-flex items-center gap-1.5 font-black tracking-tighter transition-colors leading-none overflow-visible", className)}
      style={{ color: color || 'var(--domotus-text, #000000)' }}
    >
      <span>DOMOTUS</span>
      <span className="w-[0.2em] h-[0.2em] bg-blue-600 rounded-full mt-[0.3em] shrink-0 shadow-sm shadow-blue-600/20 animate-slow-pulse"></span>
    </div>
  );
}

export function LogoIcon({ className }: { className?: string }) {
  return (
    <div className={cn("flex items-center justify-center rounded-xl bg-domotus-accent font-black text-white shadow-lg shadow-domotus-accent/20", className)}>
      D
    </div>
  );
}
